import React, { useEffect, useState, Component } from 'react';
import { CheckCircle2, ShieldCheck, Clock, CreditCard, BookOpen, FileText, Calendar, ListChecks, Star, ChevronDown, ChevronUp, ArrowRight, Gift, AlertCircle, Search, Hand, Sparkles, Apple, AlertTriangle, Target, ShoppingBag, X } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/uXox55JX6z6vfFfqTg6CnR/Untitled_design_(1).png';
const CHECKOUT_URL = 'https://checkout.tusbeneficios.shop/cart/50976043761897:1';
const CTAButton = ({
  text,
  className = ''
}: {
  text: string;
  className?: string;
}) => <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className={`w-full md:w-auto bg-amber-500 hover:bg-amber-400 text-emerald-950 font-bold text-lg py-4 px-8 rounded-full shadow-[0_4px_14px_0_rgba(245,158,11,0.39)] hover:shadow-[0_6px_20px_rgba(245,158,11,0.23)] hover:-translate-y-1 transition-all duration-200 flex items-center justify-center gap-2 ${className}`} data-id="element-0">
    {text}
    <ArrowRight className="w-5 h-5" data-id="element-1" />
  </a>;
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-emerald-100 last:border-0" data-id="element-2">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-4 flex items-center justify-between text-left focus:outline-none" data-id="element-3">
        <span className="font-semibold text-emerald-900 text-lg" data-id="element-4">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-emerald-600" data-id="element-5" /> : <ChevronDown className="w-5 h-5 text-emerald-600" data-id="element-6" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 pb-4' : 'max-h-0'}`} data-id="element-7">
        <p className="text-gray-600" data-id="element-8">{answer}</p>
      </div>
    </div>;
};
// Countdown Timer Component
const CountdownBar = () => {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          seconds = 59;
          minutes--;
        } else {
          minutes = 59;
          seconds = 59;
        }
        return {
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 bg-emerald-950 border-b-2 border-amber-500 text-white py-2 px-4 text-center text-sm font-medium shadow-md" data-id="element-9">
      <div className="flex items-center justify-center gap-2 flex-wrap" data-id="element-10">
        <AlertCircle className="w-4 h-4 animate-pulse" data-id="element-11" />
        <span className="font-semibold text-amber-400" data-id="element-12">
          ¡Oferta termina en:
        </span>
        <div className="flex gap-1 font-mono font-bold" data-id="element-13">
          <span className="bg-amber-500 text-emerald-950 px-2 py-0.5 rounded" data-id="element-14">
            {pad(timeLeft.minutes)}m
          </span>
          <span className="bg-amber-500 text-emerald-950 px-2 py-0.5 rounded" data-id="element-15">
            {pad(timeLeft.seconds)}s
          </span>
        </div>
      </div>
    </div>;
};
// Purchase notification toast
const PurchaseNotification = () => {
  const buyers = [{
    name: 'Lucas',
    city: 'Buenos Aires'
  }, {
    name: 'Martina',
    city: 'Córdoba'
  }, {
    name: 'Federico',
    city: 'Rosario'
  }, {
    name: 'Camila',
    city: 'Mendoza'
  }, {
    name: 'Joaquín',
    city: 'La Plata'
  }, {
    name: 'Valentina',
    city: 'Mar del Plata'
  }, {
    name: 'Mateo',
    city: 'Tucumán'
  }, {
    name: 'Sofía',
    city: 'Salta'
  }, {
    name: 'Tomás',
    city: 'Neuquén'
  }, {
    name: 'Agustín',
    city: 'San Juan'
  }];
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(buyers[0]);
  const [minutesAgo, setMinutesAgo] = useState(2);
  useEffect(() => {
    const showNotification = () => {
      const buyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrent(buyer);
      setMinutesAgo(Math.floor(Math.random() * 8) + 1);
      setVisible(true);
      setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showNotification, 4000);
    const interval = setInterval(showNotification, 14000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  return <div className={`fixed bottom-4 left-4 z-50 max-w-xs bg-white rounded-2xl shadow-2xl border border-emerald-100 p-4 transition-all duration-500 ${visible ? 'translate-x-0 opacity-100' : '-translate-x-[120%] opacity-0'}`} data-id="element-16">
      <div className="flex items-start gap-3" data-id="element-17">
        <div className="bg-emerald-100 text-emerald-600 p-2 rounded-full flex-shrink-0" data-id="element-18">
          <ShoppingBag className="w-5 h-5" data-id="element-19" />
        </div>
        <div className="flex-1" data-id="element-20">
          <p className="text-sm font-semibold text-emerald-950" data-id="element-21">
            {current.name} de {current.city}
          </p>
          <p className="text-xs text-gray-600" data-id="element-22">
            acaba de comprar el Capilar PRO KIT
          </p>
          <p className="text-xs text-gray-400 mt-1" data-id="element-23">hace {minutesAgo} min</p>
        </div>
        <button onClick={() => setVisible(false)} className="text-gray-300 hover:text-gray-500" aria-label="Cerrar" data-id="element-24">
          <X className="w-4 h-4" data-id="element-25" />
        </button>
      </div>
    </div>;
};
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-amber-200 selection:text-emerald-900" data-id="element-26">
      <CountdownBar data-id="element-27" />
      <PurchaseNotification data-id="element-28" />

      {/* 1. HERO SECTION */}
      <section className="bg-emerald-950 text-white pt-12 pb-16 px-4 relative overflow-hidden" data-id="element-29">
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10 pointer-events-none" data-id="element-30">
          <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-emerald-500 blur-3xl" data-id="element-31"></div>
        </div>

        <div className="max-w-3xl mx-auto relative z-10 text-center space-y-6" data-id="element-32">
          <div className="inline-block bg-emerald-800/50 border border-emerald-700 text-amber-400 font-semibold px-4 py-1.5 rounded-full text-sm" data-id="element-33">
            NUEVO MÉTODO 2024
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight tracking-tight" data-id="element-34">
            ¡Frená la caída del cabello en{' '}
            <span className="text-amber-400" data-id="element-35">30 días</span> sin gastar fortuna!
          </h1>

          {/* Mockup between title and subtitle */}
          <div className="relative mx-auto w-full max-w-[280px] py-2" data-id="element-36">
            <div className="absolute inset-0 bg-amber-500/20 blur-3xl rounded-full transform scale-90" data-id="element-37"></div>
            <img src={PRODUCT_IMAGE} alt="Capilar PRO KIT - Sistema Completo" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-38" />
          </div>

          <p className="text-lg md:text-xl text-emerald-100 max-w-2xl mx-auto" data-id="element-39">
            Sistema completo paso a paso para recuperar tu cabello desde casa,
            con resultados reales y sin promesas milagrosas.
          </p>

          <div className="pt-4 flex flex-col items-center space-y-4" data-id="element-40">
            <CTAButton text="Quiero mi Kit ahora" className="text-xl px-10 py-5" data-id="element-41" />

            <div className="flex flex-wrap justify-center gap-4 text-sm text-emerald-200/80 font-medium mt-4" data-id="element-42">
              <div className="flex items-center gap-1.5" data-id="element-43">
                <Clock className="w-4 h-4" data-id="element-44" /> Acceso inmediato
              </div>
              <div className="flex items-center gap-1.5" data-id="element-45">
                <CreditCard className="w-4 h-4" data-id="element-46" /> Pago seguro
              </div>
              <div className="flex items-center gap-1.5" data-id="element-47">
                <ShieldCheck className="w-4 h-4" data-id="element-48" /> Garantía 7 días
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. QUÉ INCLUYE EL KIT */}
      <section className="py-14 px-4 bg-white" data-id="element-49">
        <div className="max-w-5xl mx-auto" data-id="element-50">
          <div className="text-center mb-10" data-id="element-51">
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 mb-4" data-id="element-52">
              ¿Qué incluye tu acceso hoy?
            </h2>
            <p className="text-lg text-gray-600" data-id="element-53">
              Todo lo que necesitás en un solo lugar, formato digital de acceso
              inmediato.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-10" data-id="element-54">
            {[{
            icon: BookOpen,
            title: '6 Tomos Principales'
          }, {
            icon: FileText,
            title: '+36 Guías Prácticas'
          }, {
            icon: Calendar,
            title: 'Plan de 60 Días'
          }, {
            icon: ListChecks,
            title: 'Rutinas Paso a Paso'
          }].map((item, i) => <div key={i} className="bg-slate-50 rounded-xl px-3 py-4 text-center border border-slate-200 hover:border-emerald-300 transition-colors flex flex-col items-center gap-2" data-id="element-55">
                <div className="bg-white w-11 h-11 rounded-full flex items-center justify-center shadow-sm text-emerald-600" data-id="element-56">
                  <item.icon className="w-5 h-5" data-id="element-57" />
                </div>
                <h3 className="font-bold text-sm text-emerald-950 leading-tight" data-id="element-58">
                  {item.title}
                </h3>
              </div>)}
          </div>

          {/* TOMOS DETAIL */}
          <div className="border-t border-slate-200 pt-16" data-id="element-59">
            <div className="text-center mb-10" data-id="element-60">
              <h3 className="text-2xl md:text-3xl font-bold text-emerald-950 mb-3" data-id="element-61">
                Conocé los 6 Tomos del sistema
              </h3>
              <p className="text-gray-600" data-id="element-62">
                Todo lo que vas a aprender, paso a paso.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-63">
              {[{
              num: '01',
              icon: Search,
              title: 'Diagnóstico',
              desc: 'Identificá el tipo y causa real de tu caída.'
            }, {
              num: '02',
              icon: Hand,
              title: 'Frenar la caída',
              desc: 'Acciones concretas para detener el debilitamiento.'
            }, {
              num: '03',
              icon: Sparkles,
              title: 'Estimulación',
              desc: 'Técnicas para activar el crecimiento capilar.'
            }, {
              num: '04',
              icon: Apple,
              title: 'Alimentación',
              desc: 'Qué comer para nutrir tu cabello desde adentro.'
            }, {
              num: '05',
              icon: AlertTriangle,
              title: 'Errores',
              desc: 'Lo que estás haciendo mal sin darte cuenta.'
            }, {
              num: '06',
              icon: Target,
              title: 'Plan completo',
              desc: 'Tu rutina integrada de 60 días.'
            }].map((tomo, i) => <div key={i} className="relative bg-gradient-to-br from-emerald-50 to-white p-6 rounded-2xl border border-emerald-100 hover:shadow-lg hover:border-emerald-300 transition-all" data-id="element-64">
                  <div className="absolute top-4 right-4 text-5xl font-black text-emerald-100 leading-none" data-id="element-65">
                    {tomo.num}
                  </div>
                  <div className="bg-emerald-600 text-white w-12 h-12 rounded-xl flex items-center justify-center mb-4 relative z-10" data-id="element-66">
                    <tomo.icon className="w-6 h-6" data-id="element-67" />
                  </div>
                  <p className="text-xs font-bold text-emerald-600 mb-1 tracking-wider relative z-10" data-id="element-68">
                    TOMO {parseInt(tomo.num)}
                  </p>
                  <h4 className="font-bold text-xl text-emerald-950 mb-2 relative z-10" data-id="element-69">
                    {tomo.title}
                  </h4>
                  <p className="text-sm text-gray-600 relative z-10" data-id="element-70">
                    {tomo.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 6. BONOS */}
      <section className="py-14 px-4 bg-slate-50" data-id="element-71">
        <div className="max-w-4xl mx-auto" data-id="element-72">
          <div className="text-center mb-8" data-id="element-73">
            <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-800 font-bold px-4 py-2 rounded-full mb-4" data-id="element-74">
              <Gift className="w-5 h-5" data-id="element-75" />
              REGALOS EXCLUSIVOS
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-emerald-950" data-id="element-76">
              Llevate estos Bonos{' '}
              <span className="text-emerald-600" data-id="element-77">HOY GRATIS</span>
            </h2>
          </div>

          <div className="space-y-4" data-id="element-78">
            {[{
            title: 'BONO 1 — Rutinas guiadas',
            desc: 'Videos paso a paso para aplicar cada rutina sin dudas.',
            val: '$15.000'
          }, {
            title: 'BONO 2 — Productos',
            desc: 'Guía de productos económicos y efectivos recomendados.',
            val: '$10.000'
          }, {
            title: 'BONO 3 — Plan intensivo',
            desc: 'Plan de choque de 7 días para acelerar resultados.',
            val: '$12.000'
          }].map((bono, i) => <div key={i} className="bg-white border-2 border-dashed border-amber-300 rounded-xl p-6 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-79">
                <div className="flex items-center gap-4" data-id="element-80">
                  <div className="bg-amber-100 text-amber-600 p-3 rounded-full" data-id="element-81">
                    <Gift className="w-6 h-6" data-id="element-82" />
                  </div>
                  <div data-id="element-83">
                    <h3 className="font-bold text-xl text-emerald-950" data-id="element-84">
                      {bono.title}
                    </h3>
                    <p className="text-sm text-gray-500" data-id="element-85">{bono.desc}</p>
                  </div>
                </div>
                <div className="text-center sm:text-right" data-id="element-86">
                  <span className="block text-sm text-gray-400 line-through" data-id="element-87">
                    Valor normal: {bono.val}
                  </span>
                  <span className="block font-bold text-emerald-600" data-id="element-88">
                    HOY GRATIS
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 7. PRUEBA SOCIAL */}
      <section className="py-14 px-4 bg-white" data-id="element-89">
        <div className="max-w-5xl mx-auto" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-bold text-emerald-950 text-center mb-8" data-id="element-91">
            Personas reales, resultados reales
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-92">
            {[{
            name: 'Martín G.',
            text: 'En 2 semanas noté menos caída en la ducha. Es increíble lo rápido que se ven los cambios si sos constante.'
          }, {
            name: 'Alejandro S.',
            text: "Por fin entendí qué hacer. Había gastado fortuna en lociones que no servían. Este kit te explica el 'por qué' de todo."
          }, {
            name: 'Diego M.',
            text: 'Es simple y práctico. Las guías paso a paso me salvaron porque no tengo mucho tiempo a la mañana.'
          }].map((testimonial, i) => <div key={i} className="bg-slate-50 p-6 rounded-2xl border border-slate-100" data-id="element-93">
                <div className="flex gap-1 text-amber-400 mb-4" data-id="element-94">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-95" />)}
                </div>
                <p className="text-gray-700 italic mb-4" data-id="element-96">
                  "{testimonial.text}"
                </p>
                <p className="font-bold text-emerald-900" data-id="element-97">{testimonial.name}</p>
                <p className="text-xs text-gray-500" data-id="element-98">Comprador verificado</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. OFERTA */}
      <section className="py-14 px-4 bg-emerald-950 text-white relative" data-id="element-99">
        <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-101">
            Empezá tu transformación hoy
          </h2>

          <div className="bg-white text-emerald-950 rounded-3xl p-8 md:p-10 shadow-2xl max-w-2xl mx-auto" data-id="element-102">
            <div className="flex justify-center items-center gap-2 text-red-600 font-bold mb-4 animate-pulse" data-id="element-103">
              <AlertCircle className="w-5 h-5" data-id="element-104" />
              <span data-id="element-105">Oferta por tiempo limitado - Cupos limitados</span>
            </div>

            <div className="mb-6" data-id="element-106">
              <span className="text-gray-400 line-through text-2xl font-medium block mb-1" data-id="element-107">
                Precio normal: $49.990
              </span>
              <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-108">
                <span className="text-5xl md:text-7xl font-black text-amber-500 tracking-tight" data-id="element-109">
                  $19.990
                </span>
                <span className="text-sm font-bold text-white bg-red-500 px-2 py-1 rounded-md uppercase" data-id="element-110">
                  60% OFF
                </span>
              </div>
              <p className="text-sm text-gray-500 mt-2" data-id="element-111">
                Pago único. Acceso de por vida.
              </p>
            </div>

            <CTAButton text="Quiero mi Kit con 60% OFF" className="w-full text-xl py-5 mb-4" data-id="element-112" />

            <div className="flex justify-center gap-4 opacity-60" data-id="element-113">
              <span className="text-xs font-medium" data-id="element-114">
                Tarjetas de crédito, débito y MercadoPago
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* 9. GARANTÍA */}
      <section className="py-12 px-4 bg-amber-50" data-id="element-115">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8 text-center md:text-left" data-id="element-116">
          <div className="bg-amber-100 p-6 rounded-full text-amber-600 flex-shrink-0" data-id="element-117">
            <ShieldCheck className="w-16 h-16" data-id="element-118" />
          </div>
          <div data-id="element-119">
            <h2 className="text-2xl md:text-3xl font-bold text-emerald-950 mb-2" data-id="element-120">
              Garantía de 7 Días
            </h2>
            <p className="text-lg text-gray-700" data-id="element-121">
              Estamos tan seguros de que este sistema funciona que te damos 7
              días para probarlo.
              <strong className="text-emerald-800" data-id="element-122">
                {' '}
                Si no estás conforme, te devolvemos el 100% de tu dinero.
              </strong>{' '}
              Sin preguntas.
            </p>
          </div>
        </div>
      </section>

      {/* 10. FAQ */}
      <section className="py-14 px-4 bg-white" data-id="element-123">
        <div className="max-w-3xl mx-auto" data-id="element-124">
          <h2 className="text-3xl font-bold text-emerald-950 text-center mb-8" data-id="element-125">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-2" data-id="element-126">
            <FAQItem question="¿Funciona para todos los tipos de caída?" answer="El kit está diseñado para tratar las causas más comunes de debilitamiento y caída capilar, enfocándose en nutrición, cuidado del cuero cabelludo y rutinas saludables que benefician a la gran mayoría de los casos." data-id="element-127" />
            <FAQItem question="¿Cuándo voy a ver resultados?" answer="Los primeros cambios (como menor caída en la ducha) suelen notarse entre los 15 y 30 días de aplicar la rutina consistentemente. El engrosamiento y nuevo crecimiento toma un poco más de tiempo, siguiendo el ciclo natural del cabello." data-id="element-128" />
            <FAQItem question="¿Cómo recibo el producto?" answer="Es un producto 100% digital. Inmediatamente después de tu compra, vas a recibir un email con tus datos de acceso a la plataforma donde podrás ver y descargar todo el material." data-id="element-129" />
            <FAQItem question="¿Necesito experiencia o comprar productos caros?" answer="¡Para nada! El método está explicado desde cero. Además, te enseñamos a elegir productos efectivos y económicos que podés conseguir en cualquier farmacia o supermercado." data-id="element-130" />
          </div>
        </div>
      </section>

      {/* 11. CTA FINAL */}
      <section className="py-16 px-4 bg-emerald-900 text-center" data-id="element-131">
        <div className="max-w-3xl mx-auto" data-id="element-132">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-133">
            Es momento de recuperar tu confianza
          </h2>
          <p className="text-xl text-emerald-100 mb-8" data-id="element-134">
            No dejes pasar más tiempo. Empezá hoy mismo tu transformación
            capilar.
          </p>
          <CTAButton text="Quiero mi Capilar PRO KIT" className="text-2xl px-12 py-6 mx-auto" data-id="element-135" />
          <p className="mt-6 text-emerald-300 text-sm" data-id="element-136">
            Oferta válida por tiempo limitado. Acceso inmediato.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-emerald-950 text-emerald-400/60 py-8 text-center text-sm" data-id="element-137">
        <p data-id="element-138">
          © {new Date().getFullYear()} Capilar PRO. Todos los derechos
          reservados.
        </p>
        <p className="mt-2 text-xs max-w-2xl mx-auto px-4" data-id="element-139">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca comercial de FACEBOOK, Inc.
        </p>
      </footer>
    </div>;
}